module.exports = __webpack_public_path__ + "static/media/avatar_42.2196f860.svg";